module.exports = __webpack_public_path__ + "img/error-dark.42c083fc.svg";